export default class Answer {
    value!: string | null;
    image!: string | null | ArrayBuffer;
    explanation!: string | null;
    image_url!: string | null;

    constructor();
    constructor(value: string | null, image: string | null | ArrayBuffer, explanation: string | null, image_url?: string | null);
    constructor(value ?: string | null, image ?: string | null | ArrayBuffer, explanation ?: string | null, image_url ?: string | null) {
        this.value = value ?? null;
        this.image = image ?? null;
        this.explanation = explanation ?? '';
        this.image_url = image_url ?? null;
    }
}
